import { styled } from 'styled-components';

import { spacing } from '#/theme/theme';

export const TileGridCarouselHolder = styled.div`
  position: relative;
  width: 100%;
`;

export const TileGridCarouselTileHolder = styled.div`
  padding: ${spacing[8]};
  display: flex;
  place-content: center;
`;
